const initialState = { orders: null, fetchedDate: null };

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_ORDER": {
      const { data } = action;

      let memberships = state.orders || []
      let dates = state.fetchedDate || []
      data.map((membership) => {
        if (!dates.find((date) => date === membership.date)) {
          const newMembers = data.filter(a => a.date === membership.date)
          memberships = memberships.concat(newMembers)
          dates.push(membership.date)
        }
      })

      return {
        ...state,
        orders: memberships,
        fetchedDate: dates
      }
    };

    case "CREATE_ORDER": {
      let dt = state.orders.concat(action.data);
      return {
        ...state,
        orders: dt,
      };
    }
    case "UPDATE_ORDER": {
      let dt = state.orders.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        orders: dt,
      };
    }
    case "DELETE_ORDER": {
      let dt = state.orders.filter((a) => a._id !== action.data);
      return {
        ...state,
        orders: dt,
      };
    }
    default:
      return state;
  }
};

export default ordersReducer;
